import { react, useState, useEffect, useRef } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import './Summary.css';
import StyledCheckbox from '../StyledExtensions/StyledCheckbox'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import HomeIcon from '@mui/icons-material/Home';
import BusinessIcon from '@mui/icons-material/Business';
import TokenService from '../../services/TokenService';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import StarIcon from '@mui/icons-material/Star';
import PaidIcon from '@mui/icons-material/Paid';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import TipPrompt from './TipPrompt';
import Avatar from '@mui/material/Avatar';
import HowToRegIcon from '@mui/icons-material/HowToReg';

import dayjs from 'dayjs';

export default function Summary(props) {
    const ref = useRef(true);
    const [processingFees, setProcessingFees] = useState(null);
    const [totalPaymentToCustomer, setTotalPaymentToCustomer] = useState(null);
    const [agreeToTerms, setAgreeToTerms] = useState(false);
    const [requestedThisRecycler, setRequestedThisRecycler] = useState(props.pickupData.Recycler == undefined ? false : true);
    const [recyclerTip, setRecyclerTip] = useState(0);
    const [showTipPrompt, setShowTipPrompt] = useState(false);

    useEffect(() => {
        const firstRender = ref.current;

        if (firstRender) {
            ref.current = false;
            // console.log('First Render');
            getProcessingFees();
        } else {
            // console.log('Not a first Render');
        }
    });

    function getProcessingFees() {
         //GetProcessingFees(string value, string paymentMethod)
        var postData = {
            value: props.pickupRequest.Quantity,
            paymentMethod: props.pickupRequest.CustomerPaymentMethod
        }
        TokenService.post(postData, 'GetProcessingFees', '')
            .then((response) => {
                if (response !== null) {
                    response = response[Object.keys(response)[0]];
                    if (response.Result === "SUCCESS") {
                        let jsonData = JSON.parse(response.JsonData);
                        setProcessingFees("$" + jsonData.ProcessingFee);
                        if (props.pickupRequest.CustomerPaymentMethod == "Tip All") {
                            setTotalPaymentToCustomer(null);
                        }
                        else {
                            setTotalPaymentToCustomer("$" + jsonData.TotalPayment);
                        }
                       
                    }
                }
            })
            .catch((response) => {
                if (response !== null) {

                }
            });
    }
   
    function buildBusinessHours() {
        let monday = null;
        let tuesday = null;
        let wednesday = null;
        let thursday = null;
        let friday = null;
        let saturday = null;
        let sunday = null;

        let divider =
            
            <tr>
                <td colSpan='2'>
                    <div className={'SummaryTableDivider'}> </div>
                </td>
            </tr>;

        let header = <tr>
            <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                <QueryBuilderIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30 }} style={{ position: 'absolute', left: '0px' }} />
                Your Business Hours</td>
        </tr>;

        if (props.pickupRequest.hasMondayHours) {
            monday = (<tr><td>Monday:</td><td>{props.pickupRequest.mondayHoursStart.format('hh:mm a')} to {props.pickupRequest.mondayHoursEnd.format('hh:mm a') }</td></tr>)
        }

        if (props.pickupRequest.hasTuesdayHours) {
            tuesday = (<tr><td>Tuesday:</td><td>{props.pickupRequest.tuesdayHoursStart.format('hh:mm a')} to {props.pickupRequest.tuesdayHoursEnd.format('hh:mm a')}</td></tr>)
        }

        if (props.pickupRequest.hasWednesdayHours) {
            wednesday = (<tr><td>Wednesday:</td><td>{props.pickupRequest.wednesdayHoursStart.format('hh:mm a')} to {props.pickupRequest.wednesdayHoursEnd.format('hh:mm a')}</td></tr>)
        }

        if (props.pickupRequest.hasThursdayHours) {
            thursday = (<tr><td>Thursday:</td><td>{props.pickupRequest.thursdayHoursStart.format('hh:mm a')} to {props.pickupRequest.thursdayHoursEnd.format('hh:mm a')}</td></tr>)
        }

        if (props.pickupRequest.hasFridayHours) {
            friday = (<tr><td>Friday:</td><td>{props.pickupRequest.fridayHoursStart.format('hh:mm a')} to {props.pickupRequest.fridayHoursEnd.format('hh:mm a')}</td></tr>)
        }

        if (props.pickupRequest.hasSaturdayHours) {
            saturday = (<tr><td>Saturday:</td><td>{props.pickupRequest.saturdayHoursStart.format('hh:mm a')} to {props.pickupRequest.saturdayHoursEnd.format('hh:mm a')}</td></tr>)
        }

        if (props.pickupRequest.hasSundayHours) {
            sunday = (<tr><td>Sunday:</td><td>{props.pickupRequest.thursdayHoursStart.format('hh:mm a')} to {props.pickupRequest.thursdayHoursEnd.format('hh:mm a')}</td></tr>)
        }

        return (<table className='SummaryTable'>
                    <tbody>
                        {[divider, header, monday, tuesday, wednesday, thursday, friday, saturday, sunday]}
                    </tbody>
                </table>);

    }

    function buildHelpfulInfoSection() {
        let shouldShowSection = false;
        let specialInstructions = null;
        let selectedStores = null;
        let photos = null;
        let oversizedLoad = null;
        let divider =
            <tr>
                <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
            </tr>;
               
        let header = <tr>
            <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                <StarIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30 }} style={{ position: 'absolute', left: '0px' }} />
                Helpful Info
            </td>
        </tr>;

        if (props.pickupRequest.CustomerSpecialInstructions.trim().length > 0) {
            shouldShowSection = true;
            specialInstructions =
                <tr>
                    <td>Special Instructions:</td><td>{props.pickupRequest.CustomerSpecialInstructions}</td>
                </tr>;
        }

        let stores = [];
        if (props.pickupRequest.SelectedStores !== null) {
            for (let i = 0; i < props.pickupRequest.SelectedStores.length; i++) {
                stores.push(props.pickupRequest.SelectedStores[i]);
            }
        }

        if (props.pickupRequest.OtherStore !== undefined) {
            if (props.pickupRequest.OtherStore !== '') {
                stores.push(props.pickupRequest.OtherStore);
            }
        }
        if (stores.length > 0) {
            shouldShowSection = true;
            selectedStores = 
                <tr>
                    <td>Stores:</td><td>{stores.join(', ')}</td>
                </tr>;
        }

        if (props.pickupRequest.Photos !== null) {
            if (props.pickupRequest.Photos.length > 0) {
                shouldShowSection = true;
                photos = [];

                for (let i = 0; i < props.pickupRequest.Photos.length; i++) {
                    photos.push(<tr key={ props.pickupRequest.Photos[i].imageId  }><td colSpan='2' style={{textAlign:'center'} }><img src={props.pickupRequest.Photos[i].imageData} /></td></tr>)
                }
            }
        }

        if (props.pickupRequest.Quantity > 750) {
            shouldShowSection = true;
            oversizedLoad = [];
            oversizedLoad.push(<tr><td colSpan='2'><img src='/images/OversizedPickup.png' style={{ width: '60px', position: 'absolute', left: '0px', top: '20px' }} /></td></tr>)
            oversizedLoad.push(<tr>
                <td colSpan='2' style={{color:'var(--sipzee-red)', paddingBottom:'15px', paddingTop:'15px', paddingLeft:'70px'} }>Note: Due to the large bottle quantity, our returner may need to make multiple trips to complete your order.</td>
            </tr>);
        }

        if (shouldShowSection) {
            return (<table className='SummaryTable'>
                <tbody>
                    {[divider, header, oversizedLoad, specialInstructions, selectedStores, photos,]}
                </tbody>
            </table>);
           
        }
        else {
            return null;
        }
    }

    function acceptTipAmount(tipAmount) {
        console.log(tipAmount);
        setRecyclerTip(tipAmount);
        setShowTipPrompt(false);
        props.pickupRequest.TipAmount = tipAmount;
    }

    function formatMoney(val) {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',

            // These options are needed to round to whole numbers if that's what you want.
            //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
            //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
        });


        return formatter.format(val); /* $2,500.00 */

    }

    return (
        <div style={{ maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto' }}>
            <div className={styles.cardHeader}>Summary</div>

            <table className='SummaryTable'>
                <tbody>
                    <tr>
                        <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                            <SentimentSatisfiedAltIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30 }} style={{ position: 'absolute', left: '0px' }} />
                            Contact
                        </td>
                    </tr>
                    <tr>
                        <td>First:</td>
                        <td>{props.pickupRequest.CustomerName}</td>
                    </tr>
                    <tr>
                        <td>Last:</td>
                        <td>{props.pickupRequest.CustomerLastname}</td>
                    </tr>
                    {
                        (props.pickupRequest.CustomerPaymentMethod === 'Digital Check' ||
                            props.pickupRequest.CustomerPaymentMethod === 'Mailed Check') ?
                            (<tr>
                                <td>Check Payee:</td>
                                <td>{props.pickupRequest.CustomerCheckPayeeName}</td>
                            </tr>) : null
                    }

                    <tr>
                        <td>Email:</td><td>{props.pickupRequest.CustomerEmail}</td>
                    </tr>
                    <tr>
                        <td>Phone:</td><td>{props.pickupRequest.CustomerPhoneNum}</td>
                    </tr>
                    <tr>
                        <td>Text Updates:</td><td>{props.pickupRequest.CustomerWantsTextMsg ? "Yes" : "Nope"}</td>
                    </tr>
                </tbody>
            </table>
            <table className='SummaryTable'>
                <tbody>
                    <tr>
                        <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                    </tr>

                    <tr>
                        <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                            {props.pickupRequest.CustomerType === 'Residence' ?
                                <HomeIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30 }} style={{ position: 'absolute', left: '0px' }} /> : <BusinessIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30 }} style={{ position: 'absolute', left: '0px' }} />
                            }
                            Address
                        </td>
                    </tr>
                    <tr>
                        <td>

                            Street:
                        </td>
                        <td>{props.pickupRequest.CustomerAddress_Street}</td>
                    </tr>
                    {props.pickupRequest.CustomerAddress_Apt_Suit_Other === '' ? null :
                        <tr>
                            <td>Apt/Suite:</td>
                            <td>{props.pickupRequest.CustomerAddress_Apt_Suit_Other}</td>
                        </tr>
                    }

                    <tr>
                        <td>City:</td>
                        <td>{props.pickupRequest.CustomerAddress_City}</td>
                    </tr>
                    <tr>
                        <td>State:</td>
                        <td>{props.pickupRequest.CustomerAddress_State}</td>
                    </tr>
                    <tr>
                        <td>Zip:</td>
                        <td>{props.pickupRequest.CustomerAddress_Zipcode}</td>
                    </tr>
                </tbody>
            </table>
            <table className='SummaryTable'>
                <tbody>
                    <tr>
                        <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                    </tr>
                    <tr>
                        <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                            <CalendarMonthIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30 }} style={{ position: 'absolute', left: '0px' }} />
                            Pickup Availability
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Pickup on or after:
                        </td>
                        <td>{props.pickupRequest.CustomerDateAvailableForPickup.format('dddd M/d')}</td>
                    </tr>
                </tbody>
            </table>
            {props.pickupData.Recycler == undefined ? null :
                <table className='SummaryTable'>
                    <tbody>
                        <tr>
                            <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                        </tr>
                        <tr>
                            <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                                <HowToRegIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30 }} style={{ position: 'absolute', left: '0px' }} />
                                Recycler Request
                            </td>
                        </tr>
                        <tr>
                            <td>Request {props.pickupData.Recycler.FirstName.charAt(0).toUpperCase() + props.pickupData.Recycler.FirstName.slice(1)}:</td>
                            <td><StyledCheckbox checked={requestedThisRecycler} onChange={(e) => setRequestedThisRecycler(e.target.checked)} /></td>
                        </tr>
                        {
                            requestedThisRecycler == false ? null :
                                <>
                                   
                                    <tr>
                                        <td>
                                            Recycler Photo:
                                        </td>
                                        <td>
                                            <Avatar src={props.pickupData.Recycler.ImagePath == '' ? '/images/ProfileImage.png' :
                                                (props.pickupData.Recycler.ImagePath.indexOf('sipzeephotos.blob.core') > -1 ? props.pickupData.Recycler.ImagePath : 'https://sipzee.com/Returner/ReturnerProfilePics/' + props.pickupData.Recycler.ImagePath)
                                            } sx={{ width: 75, height: 75 }} />

                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan='2' style={{fontWeight:'normal'} }>
                                            * {props.pickupData.Recycler.FirstName.charAt(0).toUpperCase() + props.pickupData.Recycler.FirstName.slice(1) } will have 24 hours to schedule your pickup or we will allow any recycler to claim your order.
                                        </td>
                                    </tr>
                                </>

                        }
                    
                    </tbody>
                </table>
            }
            {props.pickupRequest.CustomerType !== 'Business' ? null :
                buildBusinessHours()
            }
            <table className='SummaryTable'>
                <tbody>
                    <tr>
                        <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                    </tr>
                    <tr>
                        <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                            <PaidIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30 }} style={{ position: 'absolute', left: '0px' }} />
                            Payment
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Bottle Quantity:
                        </td>
                        <td>{props.pickupRequest.Quantity}</td>
                    </tr>
                    <tr>
                        <td>
                            Value:
                        </td>
                        <td>{props.calculatePayment(props.pickupRequest.Quantity)}</td>
                    </tr>
                    <tr>
                        <td>
                            Financial Processing Fee:
                        </td>
                        <td>
                            {processingFees === null ?
                                <CircularProgress sx={{ color: 'var(--sipzee-green)' }} size={20} />
                                :
                                processingFees
                            }
                        </td>
                    </tr>

                    {props.pickupRequest.CustomerPaymentMethod === 'Tip All' ? null :
                        <tr>
                            <td>
                                Tip:
                            </td>
                            <td>
                                {formatMoney(recyclerTip)}
                                <Fab size="small" sx={{ fontSize: 30, marginLeft: '30px', backgroundColor: 'var(--sipzee-green)' }}
                                    onClick={() => setShowTipPrompt(true)}
                                    aria-label="add">
                                    <AddIcon sx={{ fontSize: 30 }} />
                                </Fab>
                            </td>
                        </tr>
                    }

                    {totalPaymentToCustomer == null ? null :
                        <tr>
                            <td>{props.pickupRequest.Donation == null ? 'You will receive:' : 'You are donating:'}</td>
                            <td>{formatMoney(parseFloat(totalPaymentToCustomer.toString().replace('$','')) - recyclerTip)}</td>
                        </tr>
                    }

                    {
                        props.pickupRequest.Donation === null ?
                            <tr>
                                <td>Payment Method:</td>
                                <td>{props.pickupRequest.CustomerPaymentMethod}</td>
                            </tr>
                            :
                            <tr>
                                <td>
                                    Organization
                                </td>
                                <td>{props.pickupRequest.Donation.DonationTitle}</td>
                            </tr>
                    }
                </tbody>
            </table>

            {
                buildHelpfulInfoSection()
            }

            <FormGroup style={{ marginLeft: '80px' }}>
                <FormControlLabel control={<StyledCheckbox checked={agreeToTerms} onChange={(e) => setAgreeToTerms(e.target.checked)} />} label={<span>I agree to the <a target='_blank' href='https://sipzee.com/terms-of-service.aspx'>Terms of Use</a></span>} />
            </FormGroup>


            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} >
                <div style={{ display: 'flex', width: '300px', justifyContent: 'space-between' }}>
                    <Button variant="outlined" onClick={props.onBack} style={{ marginRight: '2px' }}><KeyboardArrowLeft /> Back</Button>
                    <Button variant={agreeToTerms ? 'contained' : 'outlined'} disabled={!agreeToTerms} color="sipzeeGreen" onClick={() => props.onNext(recyclerTip, !requestedThisRecycler ? null : props.pickupData.Recycler.ReturnerGUID)}>Submit</Button>
                </div>
            </div>


            {
                (!showTipPrompt ? null :
                    <TipPrompt pickupRequest={props.pickupRequest} paymentToCustomer={totalPaymentToCustomer} onClose={() => setShowTipPrompt(false)} onAccept={(tipAmount) => acceptTipAmount(tipAmount)} />
                )
            }
        </div>
    )

}